<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin-bottom: 20px"
            type="text"
            icon="el-icon-back"
            @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
        <template>
          <el-col :span="24">
            <h2 style="margin-top: 0;">打卡详情</h2>
          </el-col>
        </template>
      <el-col :span="24">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="infoData" v-loading="this.updateLoading">
            <div>


              <el-form
                  :model="baseInfo"
                  status-icon
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
              >
                <el-form-item label="课程名称">
                  <el-col :span="15">
                    <el-input
                        v-model="baseInfo.course_title"
                        placeholder="请选择课程"
                        :disabled="true"
                        style="width: 80%"
                    ></el-input>
                  </el-col>
                  <el-button
                      v-if="create"
                      type="primary"
                      size="small"
                      @click="
            search.chooseOrgVisible = true;
            searchData();
          "
                  >
                    查询
                  </el-button>
                </el-form-item>

                <el-form-item label="打卡标题">
                  <el-input
                      v-model="baseInfo.title"
                      placeholder="打卡标题"
                      style="width: 50%"
                      :disabled="!create"
                  ></el-input>
                </el-form-item>

                <el-form-item label="起止时间">
                  <el-date-picker
                      v-model="baseInfo.start_at"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择开始时间"
                      :disabled="!create"
                      :editable="false"
                  >
                  </el-date-picker>
                  ~
                  <el-date-picker
                      v-model="baseInfo.end_at"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      default-time="23:59:59"
                      placeholder="选择结束时间"
                      :disabled="!create"
                      :editable="false"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="返现比例">
                  <el-input
                      v-model="baseInfo.cashback_ratio"
                      placeholder="返现比例"
                      @input="handleInput"
                      style="width: 15%"
                      :disabled="!create"
                  ></el-input><span style="margin-left: 2px">%</span><span style="color: red;margin-left: 15px">“返现金额”为“课程实付金额”乘以“返现比例”</span>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label="消息提醒">
                  <el-radio v-model="baseInfo.is_remind"  :label="0">关闭提醒</el-radio>
                  <el-radio v-model="baseInfo.is_remind"  :label="1">开启提醒</el-radio>
                </el-form-item>
                <el-form-item label="">

<!--                  <el-time-picker
                      v-model="baseInfo.msg_notification_at"
                      placeholder="每日通知提醒时间">
                      format="HH:mm:ss"
                  </el-time-picker>-->
                  <el-time-select
                      v-model="baseInfo.msg_notification_at"
                      format="HH:mm:ss"
                      :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '23:45'
                      }"
                      placeholder="选择时间" :editable="false">
                  </el-time-select>

                </el-form-item>
                <el-form-item label="提醒内容">
                  <el-input type="textarea" v-model="baseInfo.msg_notification" style="width: 50%;"></el-input>
                </el-form-item>
                <el-divider></el-divider>

                <el-form-item label="需连续打卡数">
                  <el-input
                      v-model="baseInfo.complete"
                      placeholder="需连续打卡次数"
                      type="number" size="medium"
                      style="width: 50%"
                      :disabled="!create"
                  ></el-input>
                </el-form-item>

                <el-form-item v-if="!baseInfo.refund_tuition" label="是否返还学费">
                  <el-radio v-model="baseInfo.refund_tuition" :disabled="!create" :label="0">否</el-radio>
                  <el-radio v-model="baseInfo.refund_tuition" :disabled="!create" :label="1">是</el-radio>
                </el-form-item>

<!--                <el-form-item label="活动说明">
                  <el-input type="textarea" v-model="baseInfo.content" style="width: 50%"></el-input>
                </el-form-item>-->

                <el-form-item label="活动说明" >
                  <tinymce v-model="baseInfo.content" style="width:66%"></tinymce>
                </el-form-item>

<!--                <el-form-item label="返学费说明">
                  <el-input type="textarea" v-model="baseInfo.explain" style="width: 50%"></el-input>
                </el-form-item>-->

                <el-form-item label="返学费说明" >
                  <tinymce v-model="baseInfo.explain" style="width:66%"></tinymce>
                </el-form-item>

                <el-form-item label="字数最小值">
                  <el-input
                      v-model="baseInfo.record_min_word"
                      type="number" size="medium"
                      style="width: 10%"
                      :disabled="false"
                  ></el-input>
                </el-form-item>

                <el-form-item label="字数最大值">
                  <el-input
                      v-model="baseInfo.record_max_word"
                      type="number" size="medium"
                      style="width: 10%"
                      :disabled="true"
                  ></el-input>
                </el-form-item>


                <el-form-item>
                  <el-button
                      size="small"
                      type="primary"
                      @click="createBaseInfo()"
                      :loading="updateLoading"
                  >确 定</el-button
                  >
                </el-form-item>
              </el-form>

              <el-dialog
                  title="选择关联课程"
                  :visible.sync="search.chooseOrgVisible"
                  :close-on-click-modal="true"
                  :before-close="addEditFormOnClose"
                  width="75%"
              >
                <el-form :inline="true" :model="search.query">
                  <!-- 模糊查询 -->
                  <el-form-item>
                    <el-input
                        size="small"
                        v-model="search.query.search"
                        placeholder="请输入标题"
                        clearable
                        @blur="searchData()"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button
                        type="primary"
                        size="small"
                        @click="
              searchData();
            "
                    >
                      查询
                    </el-button>
                  </el-form-item>
                </el-form>

<!--                <el-tabs v-model="search.activeName" @tab-click="handleClick">
                  <el-tab-pane label="普通课程" name="1"></el-tab-pane>
                  <el-tab-pane label="直播课" name="3"></el-tab-pane>
                  <el-tab-pane label="线下课" name="5"></el-tab-pane>
                  <el-tab-pane label="专题课" name="12"></el-tab-pane>
                  <el-tab-pane label="有声书" name="6"></el-tab-pane>
                </el-tabs>-->

                <!--列表-->
                <el-table
                    border
                    :data="search.result.data"
                    highlight-current-row
                    v-loading="search.listLoading1"
                    style="..."
                >
                  <el-table-column label="ID" align="center">
                    <template slot-scope="{ row }">
                      {{ row.id }}{{ row.extra_type == 1 ? ('【排期课】') : '' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="title"
                      label="标题"
                      align="center"
                  ></el-table-column>
                  <el-table-column label="图片" align="center">
                    <template slot-scope="{ row }">
                      <img :src="row.img_url" style="width: 40px" alt="" />
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="{ row }">
                      <el-button type="primary" size="small" @click="selectProduct(row)">
                        确定
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @current-change="searchData"
                    :current-page.sync="search.query.page"
                    :page-size="search.query.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="search.result.total"
                >
                </el-pagination>
              </el-dialog>
            </div>
          </el-tab-pane>

          <!--作业管理-->
          <el-tab-pane label="作业管理" name="taskListData">
            <el-row style="margin-bottom: 10px;">
              <el-input
                  class="search-el"
                  size="mini"
                  v-model="query.task_title"
                  placeholder="请输入标题"
              ></el-input>
<!--              <el-date-picker
                  v-model="query.task_date"
                  type="date"
                  placeholder="选择日期">
                  class="search-el"
              </el-date-picker>-->
              <el-date-picker
                  size="small"
                  v-model="query.task_date"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="作业日期" >
              </el-date-picker>
              <el-button type="primary" style="margin-left: 10px;" size="mini" @click="getTaskList()">
                查询
              </el-button>
            </el-row>
            <el-table :data="taskList" style="width: 100%" border  v-loading="taskListLoading" >
<!--              <el-table-column prop="id" label="ID" width="90"></el-table-column>-->
              <el-table-column prop="title" label="标题" min-width="30%"></el-table-column>
              <el-table-column prop="periods_title" label="关联章节"></el-table-column>
              <el-table-column prop="standard_rate_per" label="需完成进度" min-width="25%"></el-table-column>
              <el-table-column prop="task_date" label="日期"></el-table-column>
              <el-table-column label="操作" align="center" min-width="20%">
                <template slot-scope="{ row }">
                  <el-button
                    type="text"
                    size="mini"
                    @click="goToTaskDetails(row)">
                    编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top:10px">
              <el-pagination background @current-change="getTaskList" :current-page.sync="query.page" :page-size="query.limit"
                             layout="total, prev, pager, next, jumper" :total="taskListTotal">
              </el-pagination>
            </div>
            <el-dialog title='编辑作业' center :visible.sync='innerVisible' :before-close='outClose' append-to-body>
              <el-form :model='taskFormData' label-width='82px'>
                <el-form-item label='标题'>
                  <el-input v-model='taskFormData.title' style="width: 80%;"></el-input>
                </el-form-item>
                <el-form-item label='作业日期'>
                  <el-date-picker
                      size="small"
                      v-model="taskFormData.task_date"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="作业日期" disabled>
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="作业简介">
                  <el-input type="textarea" v-model="taskFormData.intro" style="width: 80%;"></el-input>
                </el-form-item>

                <el-form-item label="关联课程">
                  <el-input v-model="taskFormData.periods_title" style="width: 30%;" disabled></el-input>
                  <el-button type="primary" size="small" @click="taskSearchData()" style="margin-left:10px">查看</el-button>
                </el-form-item>

                <el-form-item label='需完成进度'>
                  <el-input v-model='taskFormData.standard_rate' style="width: 55px;"></el-input> %
                </el-form-item>
              </el-form>
              <span slot='footer'>
                <el-button type="primary" @click="editTask()">确 定</el-button>
                <el-button @click='innerVisible=false'>返回</el-button>
              </span>
            </el-dialog>
            <el-dialog
                title="添加课程小节"
                :visible.sync="task_search.chooseOrgVisible"
                :close-on-click-modal="true"
                :before-close="addEditPeriodsFormOnClose"
                width="75%"
            >
              <!--列表-->
              <el-table
                  border
                  :data="task_search.result.data"
                  highlight-current-row
                  v-loading="task_search.listLoading1"
                  style="..."
              >
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="type" label="类型" ></el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="duration_time" label="时长"></el-table-column>
                <el-table-column prop="file_size" label="文件大小"></el-table-column>
                <el-table-column prop="created_at" label="创建时间"></el-table-column>
                <el-table-column label="操作" align="center" width="200">
                  <template slot-scope="{ row }">
                    <el-button type="primary" size="small" @click="selectPeriods(row)">
                      确定
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  background
                  @current-change="taskSearchData"
                  :current-page.sync="task_search.query.page"
                  :page-size="task_search.query.limit"
                  layout="total, prev, pager, next, jumper"
                  :total="task_search.result.total"
              >
              </el-pagination>
            </el-dialog>
          </el-tab-pane>

          <!--日记管理-->
          <el-tab-pane label="日记管理" name="diaryListData">
            <el-row style="margin-bottom: 10px;">
              <el-input
                  class="search-el"
                  size="mini"
                  v-model="recordQuery.title"
                  placeholder="请输入标题"
              ></el-input>
              <!--              <el-date-picker
                                v-model="query.task_date"
                                type="date"
                                placeholder="选择日期">
                                class="search-el"
                            </el-date-picker>-->
              <el-date-picker
                  size="small"
                  v-model="recordQuery.task_date"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="作业日期" >
              </el-date-picker>

              <el-input
                  class="search-el"
                  size="mini"
                  v-model="recordQuery.phone_nickname"
                  placeholder="请输入手机号或昵称"
              ></el-input>
              <el-button type="primary" style="margin-left: 10px;" size="mini" @click="getRecordList()">
                查询
              </el-button>
            </el-row>
            <el-container>
              <el-aside width="50%">
                <el-table :data="recordList" style="width: 100%" border  v-loading="recordListLoading" @row-click="getRecordDetail">
                  <el-table-column label="打卡日期" width="120">
                    <template slot-scope="{row}"> <span>{{row.task_date}}</span> </template>
                  </el-table-column>
                  <el-table-column label="昵称" width="220">
                    <template slot-scope="{row}"> <span>{{row.nickname}}</span> </template>
                  </el-table-column>
                  <el-table-column label="内容" :show-overflow-tooltip="true"  width="350">
                    <template slot-scope="{row}" ><a @click="getRecordDetail(row)">{{row.content}}</a> </template>
                  </el-table-column>
                  <el-table-column
                      fixed="right"
                      label="操作"
                      width="60">
                    <template slot-scope="scope">
                      <el-button

                          type="text"
                          size="small" @click="delRecord(scope.row.id)">
                        删除
                      </el-button>
                    </template>
<!--                    <template  slot-scope="{row}">
                      <el-popconfirm
                          title="确定删除吗？"
                      >
                        <el-button slot="reference" type="text" size="small">删除</el-button>
                      </el-popconfirm>
                    </template>-->
                  </el-table-column>
              </el-table>

                <div style="margin-top:10px">
                  <el-pagination background @current-change="getRecordList" :current-page.sync="query.page" :page-size="query.limit"
                                 layout="total, prev, pager, next, jumper" :total="recordListTotal">
                  </el-pagination>
                </div>
              </el-aside>
              <el-main v-loading="recordDetailLoading" v-if="recordDetail.length!=0">
                <div style=" overflow-y:auto; overflow-x:auto; width:100%; height:700px;">
                  <template>
                    <div class="demo-type">
                      <div>
                        <el-avatar :src="this.recordDetail.avatar"></el-avatar>
                        <h2 class="cell">{{this.recordDetail.nickname}}</h2>
                      </div>


                    </div>
                    <el-divider content-position="left"><span  class="cell">提交于 {{this.recordDetail.record_time}}</span></el-divider>
                    <el-row>
                      <el-col :span="24"><div class="grid-content bg-purple-dark">{{ this.recordDetail.content }}</div></el-col>
                    </el-row>
                    <el-divider  v-if="this.recordDetail.image"></el-divider>
                    <el-row v-if="this.recordDetail.image">
                      <el-col :span="4" v-for="(item,key) in this.recordDetail.image" :key="key" >
                        <div class="grid-content bg-purple">
                          <el-image
                              style="width: 80%; height: 80%;"
                              :src="item"
                              :preview-src-list="[item]">
                          </el-image>
                        </div>
                      </el-col>
                    </el-row>
                    <el-divider  v-if="this.recordDetail.audio"></el-divider>
                    <el-row v-if="this.recordDetail.audio">
                      <el-col :span="12" v-for="(item,key) in this.recordDetail.audio" :key="key" >
                        <div class="grid-content bg-purple">
                          <audio  :src="item.path" controls="controls"></audio>
                        </div>
                      </el-col>
                    </el-row>

                  </template>
                </div>

              </el-main>
            </el-container>

          </el-tab-pane>

          <!--学员管理-->
          <el-tab-pane label="学员管理" name="studentsListData">
            <el-row style="margin-bottom: 10px;">
              <el-input class="search-el" size="mini" v-model="studentQuery.keyword" placeholder="请输入标题"></el-input>
              <el-select
                  class="search-el"
                  size="mini"
                  v-model="studentQuery.is_cert"
                  placeholder="是否获得证书"
              >
                <el-option label="全部" value="0">全部</el-option>
                <el-option label="是" value="1">是</el-option>
                <el-option label="否" value="2">否</el-option>
              </el-select>
              <el-button type="primary" size="mini" @click="getStudentList()">
                查询
              </el-button>
            </el-row>
            <el-table :data="studentList" style="width: 100%" border  v-loading="studentListLoading" >
              <el-table-column prop="nickname" label="学员"></el-table-column>
              <el-table-column prop="mobile_phone" label="手机号"></el-table-column>
              <el-table-column prop="clock_days" label="打卡天数"></el-table-column>
              <el-table-column prop="clock_num" label="打卡次数"></el-table-column>
              <el-table-column prop="is_cert" label="是否获得证书"></el-table-column>
              <el-table-column label="" align="center" min-width="35%">
                <template slot-scope="{ row }">
                  <el-button
                      type="text"
                      size="small"
                      @click="goToDetails(row.user_id)"
                  >
                    <div>详情</div>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div style="margin-top:10px">
              <el-pagination background @current-change="getStudentList" :current-page.sync="studentQuery.page" :page-size="studentQuery.limit"
                             layout="total, prev, pager, next, jumper" :total="studentListTotal">
              </el-pagination>
            </div>
          </el-tab-pane>

          <!--证书管理-->
<!--          <el-tab-pane label="证书管理" name="certificateListData">
            <el-row style="margin-bottom: 10px;">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-date-picker size="small" v-model="lockBagQuery.date" value-format="yyyy-MM-dd" type="date" placeholder="领取时间" ></el-date-picker>
                  <el-button type="primary" size="small"  style="margin-left: 10px;" @click="getLockBagList()">
                    查询
                  </el-button>
                </div>
              </el-col>

              <el-col :span="8"><div class="grid-content bg-purple-light" style="margin-left: 25em"><span class="cell">累计领取：{{this.TotalReceivedNum}}</span></div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple-light"><span class="cell">新用户累计领取：{{this.TotalNewUserReceivedNum}}</span></div></el-col>

            </el-row>
            <el-table :data="lockBagList" style="width: 100%" border  v-loading="lockBagListLoading" >
              &lt;!&ndash;              <el-table-column prop="chakras_id" label="活动ID" width="90"></el-table-column>&ndash;&gt;
              <el-table-column prop="received_luck_bag" label="体验营ID"></el-table-column>
              <el-table-column label="开课时间" width="170">
                <template slot-scope="{row}"> <span>{{row.course_begin_at}}~{{row.course_end_at}}</span> </template>
              </el-table-column>
              <el-table-column prop="course_name" label="课程"></el-table-column>
              <el-table-column prop="num" label="领取数量"></el-table-column>
              <el-table-column prop="received_new_user_num" label="新用户领取数量"></el-table-column>
            </el-table>
          </el-tab-pane>-->

          <!--数据分析-->
          <el-tab-pane label="数据分析" name="dataAnalysisList">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple" style="border: 1px solid #f2f2f2;">
                  <div style="margin-left: 20px">
                    <p style="font-size: 15px">打卡次数</p>
                    <span style="font-size: 25px">{{this.todayDailyTotal}}</span>
                    <p>昨日 {{this.yesDailyTotal}}</p>
                    <p>累计 {{this.dailyTotal}}</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple" style="border: 1px solid #f2f2f2;">
                  <div style="margin-left: 20px">
                    <p style="font-size: 15px">打卡人数</p>
                    <span style="font-size: 25px">{{this.todayDailyTotal}}</span>
                    <p>昨日 {{this.yesDailyTotal}}</p>
                    <p>累计 {{this.dailyTotal}}</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple" style="border: 1px solid #f2f2f2;">
                  <div style="margin-left: 20px">
                    <p style="font-size: 15px">新增学员</p>
                    <span style="font-size: 25px">{{this.todayUserTotal}}</span>
                    <p>昨日 {{this.yesUserTotal}}</p>
                    <p>累计 {{this.userTotal}}</p>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 20px">
              <el-table :data="dataAnalysisList" style="width: 100%" border  v-loading="dataAnalysisListLoading" >
                <el-table-column prop="date_time" label="时间"></el-table-column>
                <el-table-column prop="daily_num" label="打卡次数"></el-table-column>
                <el-table-column prop="daily_users" label="打卡人数"></el-table-column>
                <el-table-column prop="add_users" label="新增学员"></el-table-column>
                <el-table-column prop="like_num" label="点赞数"></el-table-column>
              </el-table>
              <div style="margin-top:10px">
                <el-pagination background @current-change="getDataAnalysisList" :current-page.sync="dataAnalysisQuery.page" :page-size="dataAnalysisQuery.limit"
                               layout="total, prev, pager, next, jumper" :total="dataAnalysisListTotal">
                </el-pagination>
              </div>
            </el-row>
          </el-tab-pane>

        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import tinymce from "@/components/tinymce.vue";
import {
  screenProductList,
} from "@/api/coupon";

import {
  getAttendanceInfo,
  createAttendance,
  getTaskList,
  getStudentList,
  dataAnalysisList,
  editAttendanceTask,
  getAttendanceRecordList,
  delAttendanceRecord,
  getPeriodList
} from "@/api/clockIn";
/*import { setTimeout } from 'timers';*/

export default {
  data: function() {
    return {
      create: true,
      updateLoading: false,
      baseInfo: {
        id: 0,
        title: "",
        object_id: 0,
        start_at:"",
        end_at:"",
        complete: "",
        refund_tuition: 1,
        content: "",
        explain: "",
        course_title:"",
        is_remind:0,
        msg_notification_at:"",
        msg_notification:"",
        record_min_word: 20,
        record_max_word: 800,
        cashback_ratio: 20.00,
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 1,
          extra_type: 2,// 限定非排期课，0-不限（即全部），1-限定搜排期课，2-限定搜非排期课
        },
        result: {
          total: 0,
          data: [],
        },
      },

      userLevelList:[],
      query:{
        level_id:'',
        create_platform:'',
        platform:'',
        stage:'',
        page:1,
        limit:20,
        task_title:'',
        task_date:'',
        team_start_at:'',

      },
      activeName: 'infoData',
      dataLoading:true,
      listLoading:true,

      //作业管理
      taskList:[],
      taskListLoading:false,
      taskListTotal:0,
      innerVisible: false,
      taskFormData:{
        id:0,
        attendance_id:this.$route.query.id,
        title:"",
        intro:"",
        task_date:"",
        standard_rate:0,
        periods_title:"",
      },

      task_search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page:1,
          limit:20,
          course_id: 0,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      //日记管理
      recordList:[],
      recordListLoading:false,
      recordDetailLoading:false,
      recordListTotal:0,
      recordDetail:[],
      recordQuery:{
        title:"",
        task_date:"",
        phone_nickname:"",
        attendance_id:this.$route.query.id,
      },


      //学员管理
      studentList:[],
      studentListLoading:true,
      studentListTotal:0,
      recordAvatar:"https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      studentQuery:{
        page: 1,
        limit: 10,
        keyword: "",
        is_cert: "",
        attendance_id: this.$route.query.id,
      },

      //数据分析
      dataAnalysisList: [],
      dataAnalysisListLoading: true,
      dataAnalysisListTotal: 0,
      dailyTotal: 0,
      userTotal: 0,
      todayDailyTotal: 0,
      todayUserTotal: 0,
      yesDailyTotal: 0,
      yesUserTotal: 0,
      dataAnalysisQuery: {
        page: 1,
        limit: 10,
        attendance_id: this.$route.query.id,
      },

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      lockBagQuery:{
        date:'',
      },
    };
  },
  components: {
    tinymce,
  },
  created: function() {
    /*this.getData();*/
    let channel = localStorage.getItem('channel_type');
    console.log(channel);
    if (channel == 1) {
      this.activeName = 'studentsListData';
      this.getStudentList();
      localStorage.setItem('channel_type', '')
    }
    this.getAttendanceInfo();
  },
  methods: {
    inputCashbackRatioChange(val) {
      this.baseInfo.cashback_ratio = this.baseInfo.cashback_ratio.replace(/^(0|[1-9]\d*)(\.\d{1,2})?$/, '')
    },
    handleInput(e) {
      console.log(e);
      let value = e
          .replace(/[^\d.]/g, '')          // 清除非数字和小数点[3](@ref)
          .replace(/(\..*)\./g, '$1')      // 禁止多个小数点[1,5](@ref)
          .replace(/^0+(\d)/, '$1')        // 修正前导零（如012→12，但允许0）[3,5](@ref)

      // 拆分整数与小数部分
      const parts = value.split('.');
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2); // 限制小数点后两位[1,4](@ref)
        value = parts.join('.');
      }

      // 验证整体格式（0、正整数或两位小数）
      if (!/^(0|[1-9]\d*)(\.\d{0,2})?$/.test(value)) {
        value = value.slice(0, -1);       // 删除最后一个非法字符[1,7](@ref)
      }

      if(value > 100) {
        value = 100;
      }

      this.baseInfo.cashback_ratio = value;
    },
    //基本信息
    getAttendanceInfo() {
      this.baseInfo.id = this.$route.query.id;
      if(this.baseInfo.id > 0){
        this.create = false;
      }
      this.loading = true;
      if(this.baseInfo.id == 0){
        return;
      }
      this.updateLoading = true;
      getAttendanceInfo({
        id: this.baseInfo.id,
      }).then((response) => {
        if (response.status == 2000) {
          this.baseInfo = response.data;
          this.updateLoading = false;
        }
        this.loading = false;
      });
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "1";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;

    },
    selectProduct(row) {
      /*if (this.saleInfo.type == 2 && row.extra_type != undefined && row.extra_type == 1) {
        this.$message({
          showClose: false,
          message: '请再秒杀列表点击“新建排期课程秒杀” 创建排期课的秒杀活动',
          type: "error",
        });
        return;
      }*/
      this.baseInfo.object_id = row.id;
      this.baseInfo.course_title = row.title;

      this.search.chooseOrgVisible = false;
    },

    // 查询方法
    taskSearchData() {
      console.log(this.baseInfo.object_id)
      this.task_search.chooseOrgVisible = true;
      this.task_search.listLoading1 = true;
      this.task_search.query.course_id = this.baseInfo.object_id;
      getPeriodList(this.task_search.query).then((response) => {
        this.task_search.result.data = response.data.list;
        this.task_search.result.total = response.data.total;
        this.task_search.listLoading1 = false;
      });
    },

    selectPeriods(row) {
      this.taskFormData.periods_title = row.title
      this.taskFormData.period_id = row.id
      this.addEditPeriodsFormOnClose();
    },
    addEditPeriodsFormOnClose() {
      this.task_search.query.page = 1;
      this.task_search.query.course_id = 0;
      this.task_search.result = {
        total: 0,
        data: [],
      };
      this.task_search.chooseOrgVisible = false;
    },

    createBaseInfo() {
      if(this.baseInfo.cashback_ratio == ''){
        this.$message({
          showClose: true,
          message: '请填写“返现比例”后，再进行提交',
          type: "error",
        });
        return false;
      }
      this.updateLoading = true;
      createAttendance(this.baseInfo)
          .then((response) => {
            this.updateLoading = false;
            if (response.status == 2000) {
              this.$message.success(response.message);
              this.$router.push({
                path: "/clockIn/list",
              });
            }
          })
          .catch((err) => {
            console.log(err)
            this.updateLoading = false;
          });
    },

    //作业管理
    getTaskList(){
      this.taskListLoading = true;
      this.query.attendance_id = this.baseInfo.id;
      getTaskList(this.query).then(response => {
        this.taskList = response.data.list
        this.taskListLoading = false;
        this.taskListTotal = response.data.total;
      });
    },
    goToTaskDetails(row){
      this.taskFormData = row
      this.innerVisible = true
      /*this.$router.push({
        path: "/clockIn/info",
        query: {id:id}
      });*/
    },
    outClose(done) {
      this.$confirm('确认关闭', '提示框').then(() => {
        done()
      }).catch(() => {

      })
    },
    editTask(){
      this.$confirm('确认保存', '提示框').then(() => {
        editAttendanceTask(this.taskFormData)
            .then((response) => {
              if (response.status == 2000) {
                this.innerVisible = false;
                this.$message.success(response.message);
                this.getTaskList()
              }
            })
            .catch((err) => {
              console.log(err)
              this.innerVisible = true;
            });
      }).catch(() => {

      })
    },

    //日记管理
    getRecordList(){
      this.recordListLoading = true;
      this.recordDetailLoading = true;
      this.recordQuery.attendance_id = this.baseInfo.id;
      getAttendanceRecordList(this.recordQuery).then(response => {
        this.recordList = response.data.list
        this.recordListLoading = false;
        this.recordListTotal = response.data.total;
        if(this.recordListTotal){
          this.recordDetail = this.recordList[0]
        }
        this.recordDetailLoading = false;
      });
    },

    getRecordDetail(row){
      this.recordDetail = row;
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    /*delRecord(id){
      delAttendanceRecord({id:id}).then(response=>{
        this.$message.success(response.message);
        if(response.status == 2000){
          this.getRecordList()
        }
      })
    },*/
    delRecord(id){
      this.$confirm('此操作将删除活动信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        delAttendanceRecord({id}).then(response => {
          if(response.status == 2000){
            this.getRecordList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }else{
            this.$message({
              showClose: true,
              duration: 6000,
              message: response.message,
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    },
    getStudentList(){
      this.studentListLoading = true;
      getStudentList(this.studentQuery).then(response => {
        this.studentList = response.data.list
        this.studentListTotal = response.data.total;
        this.studentListLoading = false;
      });
    },

    goToDetails(user_id) {
      localStorage.setItem('channel_type', '1')
      this.$router.push({
        path: "/clockIn/info/student/details",
        query: {
          user_id: user_id,
          attendance_id: this.studentQuery.attendance_id
        }
      });
    },

    getDataAnalysisList(){
      this.dataAnalysisListLoading = true;
      dataAnalysisList(this.dataAnalysisQuery).then(response => {
        this.dataAnalysisList = response.data.list
        this.dataAnalysisListTotal = response.data.total;
        this.dailyTotal = response.data.daily_total;
        this.userTotal = response.data.user_total;
        this.todayDailyTotal = response.data.today_daily_total;
        this.todayUserTotal = response.data.today_user_total;
        this.yesDailyTotal = response.data.yes_daily_total;
        this.yesUserTotal = response.data.yes_user_total;
        this.dataAnalysisListLoading = false;
      });
    },

    handleClick(tab) {
      switch (tab.name) {
          //基本信息
        case 'infoData':
          this.getAttendanceInfo();
          break;
          //作业管理
        case 'taskListData':
          this.getTaskList();
          break;
        case 'diaryListData':
          this.getRecordList();
          break;
          //学员管理
        case 'studentsListData':
          this.getStudentList();
          break;
          //数据分析
        case 'dataAnalysisList':
          this.getDataAnalysisList();
          break;
      }
    },
  }
};
</script>

